export const TAXONOMY_TYPES = {
  CATEGORY: 'category',
  APP: 'APP',
  GAME: 'GAME',
}
